import store from './store'
// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/messaging'
import 'firebase/analytics'

import Vue from 'vue'

Vue.prototype.$serverKey = "AAAA8XN4y3I:APA91bFz5yS7xYZlJQt9tyu37BTXhBA3hyFJ13W622Q8GKjs1S4Z_m4Mrowjsid0ZLeH0wVTy4W67-ZIQ0Bh4uaSb7Q6Mx4BJ0p8Zb2Dds1wIqzDdMBuFqFJBmBp_DKRCMwm7GHgKerw"
// Your web app's Firebase configuration
const firebaseConfig = {
	apiKey: "AIzaSyBkpCRpG5GVqoYBLdK46KmBpx6qJosywmU",
	authDomain: "nanocomputingandroid-4fa8c.firebaseapp.com",
	databaseURL: "https://nanocomputingandroid-4fa8c.firebaseio.com",
	projectId: "nanocomputingandroid-4fa8c",
	storageBucket: "nanocomputingandroid-4fa8c.appspot.com",
	messagingSenderId: "1037024414578",
	appId: "1:1037024414578:web:2873726cabf7d2ad102beb",
	measurementId: "G-GZQDXLYJ0L"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig)

const messaging = firebase.messaging()
// [END get_messaging_object]
// [START set_public_vapid_key]
// Add the public key generated from the console here.
messaging.usePublicVapidKey('BAWfgZ2RfjRwjaE1iuCZzN959SGakL8k8WqZuKK6DF17HvkiuaiAdDKq2ydzJlql6RfEnyzSUYOKlkeYuboOoKk')

messaging.onMessage((payload) => {
	console.log('Message received. ', payload)	
	store.commit('new_notification',payload)
});

firebase.analytics()

export default {
	messaging
}
	